module.exports = __webpack_public_path__ + "img/20200309155121167.7ca33955.jpg";